import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DataTable from 'base/components/table/DataTable/index';
import MainTitle from 'base/components/MainTitle/index';
import Header from 'base/components/Header/index';
import {
  AppsIcon,
  AddIcon,
  FileUploadIcon,
  ImportContactsIcon,
  CheckIcon,
  CloseIcon,
} from 'base/components/Icon/index';
import { fetchAllUsers, setEditingUserId } from 'auth/store/users/actions';
import { getAllUsers } from 'auth/store/users/selectors';
import { getRolesById } from 'auth/store/roles/selectors';
import theme from 'theme/theme';
import Button from 'base/components/Button/index';
import ButtonGroup from 'base/components/ButtonGroup';
import { getEditColumn, getDeleteColumn } from 'base/components/table/RowActionButton';
import {
  DateCell, DateTimeCell, SmallLabelCell, SmallLabelListCell,
} from 'base/components/table/Cells';
import LargeLabel from 'base/components/LargeLabel';
import SmallLabel from 'base/components/SmallLabel';
import withGlobalFilter from 'base/components/table/withGlobalFilter';
import { openModal } from '../../../modal';

const NameCell = ({ row, original }) => ( // eslint-disable-line
  <div>
    <LargeLabel>
      {original.firstName}
      {' '}
      {original.lastName}
    </LargeLabel>
    <SmallLabel>{original.email}</SmallLabel>
  </div>
);

const FilteredTable = withGlobalFilter(DataTable);

class ManageUsers extends React.Component {
  componentDidMount() {
    const { fetchAll } = this.props;
    fetchAll();
  }

  handleEdit = (data) => {
    const { setActiveUserId, openModal } = this.props;
    setActiveUserId(data.id);
    openModal('USER_EDIT');
  };

  handleDelete = (data) => {
    const { setActiveUserId, openModal } = this.props;
    setActiveUserId(data.id);
    openModal('USER_DELETE');
  };

  render() {
    const { users, openModal, rolesById } = this.props;

    const columns = [
      {
        Header: 'Name',
        id: 'name',
        accessor: (row) => `${row.firstName} ${row.lastName} - ${row.email}`,
        Cell: NameCell,
        showOnMobile: true,
      },
      {
        Header: 'Roles',
        id: 'roles',
        accessor: (row) => row.roles && row.roles.map((id) => rolesById[id].name),
        Cell: SmallLabelListCell('roles'),
        showOnMobile: true,
      },
      {
        Header: 'Dashboard',
        id: 'dashboard',
        accessor: (row) => {
          if (row.dashboard) {
            return 'Custom';
          } if (!row.dashboard && row.defaultDashboard) {
            return row.defaultDashboard.name
              ? row.defaultDashboard.name : 'Unnamed default dashbaord';
          }
          return 'Minimal (none set)';
        },
        Cell: SmallLabelCell('dashboard'),
        width: 200,
      },
      {
        Header: 'Status',
        id: 'isActive',
        accessor: (row) => (row.isActive ? 'active' : 'disabled'),
        Cell: SmallLabelCell('isActive'),
        width: 90,
      },
      {
        Header: <ImportContactsIcon color={theme.colors.medium} />,
        id: 'denyContactList',
        // accessor: row => (row.denyContactList ? 'n' : 'y'),
        Cell: ({ original }) => (
          <SmallLabel>{original.denyContactList ? <CloseIcon /> : <CheckIcon />}</SmallLabel>
        ),
        width: 50,
      },
      {
        Header: 'Created',
        accessor: 'createdAt',
        Cell: DateCell('createdAt'),
        width: 120,
      },
      {
        Header: 'Last seen',
        accessor: 'lastLoginAt',
        Cell: DateTimeCell('lastLoginAt'),
        width: 155,
      },
      getEditColumn(this.handleEdit),
      getDeleteColumn(this.handleDelete),
    ];

    return (
      <>
        <Header>
          <MainTitle>
            <AppsIcon />
            {' '}
Manage Users
          </MainTitle>
          <ButtonGroup pullRight>
            <Button onClick={() => openModal('CONTACT_IMPORT')}>
              <FileUploadIcon color={theme.colors.medium} />
              {' '}
Import from CSV
            </Button>
            <Button onClick={() => openModal('USER_CREATE')}>
              <AddIcon color={theme.colors.medium} />
              {' '}
New user
            </Button>
          </ButtonGroup>
        </Header>
        <FilteredTable
          data={users}
          columns={columns}
          defaultSorted={[{
            id: 'createdAt',
            desc: true,
          }]}
          filterKeys={['name', 'roles', 'dashboard', 'isActive']}
          filterLabel="Filter by name, email, role, dashboard, status..."
        />
      </>
    );
  }
}
ManageUsers.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  rolesById: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchAll: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  setActiveUserId: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
  users: getAllUsers(state),
  rolesById: getRolesById(state),
});

const mapDispatchToProps = {
  fetchAll: fetchAllUsers,
  openModal,
  setActiveUserId: setEditingUserId,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageUsers);
